// extracted by mini-css-extract-plugin
export default {"root":"GameContainer_root__Yf-Jp"};